import type { ReactNode } from "react";

/**
 * L-8: tresc to karty-siostry na washu, nigdy jeden mega-panel.
 * T-2: karta w karcie jest ZAKAZANA - jesli sekcja "potrzebuje" karty w srodku,
 * znaczy, ze jest za duza i trzeba ja podzielic na dwie karty-siostry.
 * T-3: karte definiuje hairline 1px --border; cien tylko w light (--card-shadow).
 *
 * Klasy `.card` i `.card-title` sa juz w content.css - ten komponent tylko je sklada,
 * zeby naglowek z akcjami wygladal tak samo w kazdym widoku (F-2: pasek "tytul +
 * akcje" jest celowo asymetryczny, tytul z lewej, akcje z prawej).
 */
export function Card({
  tytul,
  akcje,
  children,
  ...reszta
}: {
  tytul?: string;
  akcje?: ReactNode;
  children: ReactNode;
} & React.HTMLAttributes<HTMLElement>): React.JSX.Element {
  return (
    <section className="card" {...reszta}>
      {(tytul || akcje) && (
        <div className="card-head">
          {tytul && <h2 className="card-title">{tytul}</h2>}
          {akcje && <div className="card-head__akcje">{akcje}</div>}
        </div>
      )}
      {children}
    </section>
  );
}
